// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".system_drawer_inner[data-v-2295e98e] {\n  text-align: right;\n  padding: 0.3125rem 0.625rem;\n  margin-bottom: 0 !important;\n  height: 2.5rem;\n}\n.system_drawer_inner .img[data-v-2295e98e] {\n  width: 1.875rem;\n  height: 1.875rem;\n  cursor: pointer;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
